import { useParams, useNavigate } from "react-router";
import PageMeta from "../../components/common/PageMeta";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import NewPixelForm from "../../components/pixel/NewPixelForm";

export default function NewPixel() {
    const { productId } = useParams<{ productId: string }>();
    const navigate = useNavigate();

    // Função para voltar à página anterior
    const handleGoBack = () => {
        navigate(`/products/edit/${productId}?tab=pixel`);
    };

    return (
        <>
            <PageMeta
                title="Sellyo - Novo Pixel"
                description="Criar novo pixel para o produto"
            />
            <PageBreadcrumb
                pageTitle="Novo Pixel"
                showBackButton={true}
                onBack={handleGoBack}
            />

            <div className="container mx-auto px-4 md:px-6">
                <NewPixelForm
                    productId={productId || ''}
                    onSuccess={() => {
                        // Redirecionar para a página de edição do produto na aba de pixels
                        navigate(`/products/edit/${productId}?tab=pixel`);
                    }}
                    onError={(error) => {
                        console.error("Erro ao criar pixel:", error);
                    }}
                />
            </div>
        </>
    );
}